import { Group, Field, SaveBar, Toggle, useDraft, useSectionSave } from "./shared";

export const StatsSection = () => {
  const { settings, save, busy } = useSectionSave();
  const [st, setSt] = useDraft(settings.stats);
  const s = (k) => (v) => setSt({ ...st, [k]: v, ...(k === "use_custom" ? {} : { use_custom: true }) });
  return (
    <div className="space-y-6" data-testid="stats-section">
      <Group title="Stats & Metrics Settings" desc="These two numbers appear in the homepage hero section under the main buttons.">
        <div className="grid gap-4 md:grid-cols-2">
          <Field label="Approved Members Count" type="number" min={0} value={st.approved_members} onChange={s("approved_members")} testId="stats-members-input" />
          <Field label="Support Distributed Amount in ETB" type="number" min={0} value={st.total_support} onChange={s("total_support")} testId="stats-support-input" />
        </div>
        <Toggle label="Show these numbers on the homepage" desc="Turned on automatically when you type a number. Turn off to show live counts from the database instead." checked={st.use_custom} onChange={s("use_custom")} testId="stats-custom-toggle" />
      </Group>
      <SaveBar onClick={() => save({ stats: { ...st, approved_members: Number(st.approved_members) || 0, total_support: Number(st.total_support) || 0 } })} busy={busy} testId="stats-save-btn" />
    </div>
  );
};
